module.exports = __webpack_public_path__ + "img/04.820f6a7e.png";